import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';
import { detectTransition, pendingRecipes } from './mixins/recipe_transition';

export default class extends Controller {
  static values = {
    originalRecipes: Array,
    transitionMappings: Array,
  };

  interceptSubmit(event) {
    if (!detectTransition(this.originalRecipesValue, this.transitionMappingsValue, pendingRecipes())) return;
    event.preventDefault();
    const modalEl = document.getElementById('recipe-transition-guidance');
    if (!modalEl) return;
    Modal.getOrCreateInstance(modalEl).show();
  }

  // Opens the unified Confirm Changes modal instead of submitting. Keeping the
  // trigger a type=submit button lets account-plan-type keep disabling it until
  // the plan changes; the modal's own Confirm button submits the form.
  openConfirmationModal(event) {
    event.preventDefault();
    const modalEl = document.getElementById("plan-change-confirmation");
    if (!modalEl) return;
    Modal.getOrCreateInstance(modalEl).show();
  }

  discard() {
    window.location.reload();
  }
}
